<script setup>

const props = defineProps({
  flex: {
    type: Boolean,
		default: false
  }
})

</script>

<template>
	<div class="relative aspect-square" :class="[flex ? 'w-[280px]' : 'w-full']">
		<Loader class="absolute left-[50%] top-[50%] z-10 -translate-x-[50%] -translate-y-[50%]" />
		<div class="relative z-20"><slot /></div>
	</div>
</template>